export const DEFINE_MODULE = {
  name: "cơ sở",
  fields: "locations",
}
